import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiWarrantyServicesList, apiWarrantyServicesView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/warrantyServices/getData', async datas => {
    const { data } = await apiWarrantyServicesList(datas)
    return data
})

export const getView = createAsyncThunk('admin/warrantyServices/getView', async id => {
    const { data } = await apiWarrantyServicesView(id)
    return data
})

export const warrantyServicesSlice = createSlice({
    name: 'admin/warrantyServices',
    initialState: {
        loading: true,
        view: null,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: '',
            service_staff_id: '',
            start: '',
            end: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
        setServiceStaff: (state, { payload }) => {
            state.table.page = 1
            state.table.service_staff_id = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = null
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
            .addCase(getView.rejected, state => {
                state.loading = false
                state.view = null
            })
    },
})

export const { setData, setTableData, setStatus, setServiceStaff, setDate } = warrantyServicesSlice.actions

export default warrantyServicesSlice.reducer
